import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initCategoryGrid = () => {
  const sliders = document.querySelectorAll('.category-grid__container');
  if (sliders.length == 0) return;

  sliders?.forEach((slider) => {
    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: '.category-grid__swiperBtn .swiper-btn-next',
        prevEl: '.category-grid__swiperBtn .swiper-btn-prev',
        disabledClass: 'pointer-events-none opacity-50',
      },
      watchOverflow: true,
      breakpoints: {
        375: {
          slidesPerView: 1.37867,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.7,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.3,
          spaceBetween: 24,
        },
        1536: {
          slidesPerView: 4.1777,
          spaceBetween: 32,
        },
      },
    };
    new Swiper(slider, swiperOptions);
  });
};
